import { useTranslation } from "react-i18next";

export const Marquee = () => {
  const { t } = useTranslation();
  const items = t("marquee.items", { returnObjects: true });
  const row = [...items, ...items, ...items];

  return (
    <div data-testid="marquee" className="border-y border-line py-6 md:py-8 overflow-hidden bg-sand">
      <div className="marquee-track">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center whitespace-nowrap">
                <span className="font-serif italic text-3xl md:text-5xl text-ink/80 px-6">{item}</span>
                <span className="w-2 h-2 rounded-full bg-terracotta/70 mx-4" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
